import React, { useEffect, useState } from 'react';
import { firestore} from '../firebase';
import { useUserContext } from "./UserContext";

var ProfileStateContext = React.createContext();
var ProfileDispatchContext = React.createContext();
var ProfilesContext = React.createContext();

function ProfileReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function ProfilesProvider({ children }) {
  const [profiles, setProfiles] = useState(null);
  const [loading, setLoading] = useState(false);
  var admin = useUserContext().userInformation.admin;

  useEffect(() => {
    setLoading(true);
    setProfiles(null);
    if (admin === 'undefined' && profiles) {
      setProfiles(null)
      setLoading(false)
    } else if(admin && !profiles) {
      getProfileList().then((profileList) => {
        setProfiles(profileList)
        setLoading(false)
      });
    } else {
      setLoading(false)
    }
  }, [admin]);

  var [state, dispatch] = React.useReducer(ProfileReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <ProfileStateContext.Provider value={state}>
      <ProfileDispatchContext.Provider value={dispatch}>
        <ProfilesContext.Provider value={{profiles, setProfiles, loading}}>
          {children}
        </ProfilesContext.Provider>
      </ProfileDispatchContext.Provider>
    </ProfileStateContext.Provider>
  );
}

function useProfileState() {
  var context = React.useContext(ProfileStateContext);
  if (context === undefined) {
    throw new Error("useProfileState must be used within a ProfileProvider");
  }
  return context;
}

function useProfileDispatch() {
  var context = React.useContext(ProfileDispatchContext);
  if (context === undefined) {
    throw new Error("useProfileDispatch must be used within a ProfileProvider");
  }
  return context;
}

function useProfilesContext() {
  var context = React.useContext(ProfilesContext);

  if (context === undefined) {
    throw new Error("useProfileContext must be used within a ProfileProvider");
  }
  return context;
}

export { ProfilesProvider, useProfileState, useProfileDispatch, useProfilesContext, getProfileList };

// ###########################################################

function getProfileList() {
  return new Promise ((resolve, reject) => {
    firestore
        .collection('Users')
        // .where('__name__', '!=', localStorage.getItem('user_uid'))
        .get()
        .then((snapshot) => {
          resolve(snapshot.docs.map(formatProfile))
        })
        .catch((error) => reject(error));
  });
};

function formatProfile(profileDoc) {
  const data = profileDoc.data();
  console.log(data);
  return{
    id: profileDoc.id,
    name: data.name,
    email: data.email,
    avatar: data.avatar,
    surveyCompleted: data.surveyCompleted,
    survey: data.survey,
  }
};